(function (global, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  global.SGLDIYConfigurator = api;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { api.initAll(document); }, { once: true });
    else api.initAll(document);
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var runtime = typeof window !== 'undefined' ? window : globalThis;
  var GROUP_ORDER = ['fittings', 'wood', 'fishskin'];
  var LAYER_ORDER = ['wood', 'fishskin', 'fittings'];
  var GROUPS = {
    fittings: {
      number: '01',
      label: 'FITTINGS',
      short: '装具材质',
      title: '选择整套装具材质',
      help: '所选材质将统一应用于当前单品的全部可变装具，装具形制与纹样保持不变。',
      summary: '包括剑格、剑首、鞘口、鞘尾与鞘箍等装饰金属件；页面只更换材质表现，不改变当前单品的装具造型。'
    },
    wood: {
      number: '02',
      label: 'WOOD',
      short: '木材',
      title: '选择木鞘与柄部木材',
      help: '木鞘主体与可见柄部使用同一种木材，选择后两处会同步变化。',
      summary: '木材同时用于完整木鞘和可见柄部；若再选择鱼皮，页面会按当前单品已开放的包覆部位同步展示。'
    },
    fishskin: {
      number: '03',
      label: 'RAY SKIN',
      short: '鱼皮包覆',
      title: '选择鱼皮样式与颜色',
      help: '可保留所选木材，或选择当前单品已开放的鱼皮样式与颜色。未列出的常规颜色可在其他定制需求中说明。',
      summary: '先选择鱼皮样式，再选择颜色；未选择鱼皮时保留木材外观。鱼皮只改变当前单品已开放部位的表面效果，不改变装具与刀剑结构。'
    }
  };

  var COPY = {
    baseSuffix: '（基础款）',
    productNoteTemplate: '{summary}',
    restoreCurrentProduct: '已恢复当前单品基础款。',
    inquiryIntro: '您好，我想咨询「{product}」的定制：',
    currentProduct: '当前单品',
    unselected: '未选择',
    unselectedKeepWood: '未选择（保留木材）',
    otherRequirementsPrefix: '其他定制需求：',
    inquirySubject: '沈广隆定制咨询｜{product}',
    consultationLoading: '正在载入可用咨询方式…',
    consultationReady: 'WhatsApp 与 Email 会自动带入本次配置；使用 LINE 或微信时可先复制咨询内容。',
    consultationUnavailable: '咨询方式暂未载入，请前往联系页面继续沟通。',
    productNoteFallback: '从当前基础款出发选择已开放材质。',
    matchingRecorded: '搭配已记录，请选择咨询方式。',
    inquiryCopied: '咨询内容已复制。',
    inquiryCopyFailed: '请手动复制咨询内容。',
    unavailable: '暂未开放',
    conflictPrefix: '与当前',
    conflictSuffix: '不兼容',
    fishskinStylePrompt: '先选择鱼皮样式',
    fishskinColorPrompt: '选择该样式的颜色（以下仅为代表色）',
    nextLabel: '下一步',
    completeLabel: '完成搭配',
    enterConsultation: '进入私域咨询',
    noGroupMaterials: '这个单品的本组材质尚未录入。'
  };

  function fillCopyTemplate(template, values) {
    var output = String(template || '');
    Object.keys(values || {}).forEach(function (token) { output = output.split(token).join(values[token]); });
    return output;
  }

  function splitList(value) {
    return String(value || '').split(',').map(function (item) { return item.trim(); }).filter(Boolean);
  }

  function optionsFor(config, state, group) {
    return config.options.filter(function (option) {
      return option.productId === state.productId && option.group === group && option.availability === 'available';
    }).sort(function (left, right) {
      return Number(Boolean(right.isDefault)) - Number(Boolean(left.isDefault));
    });
  }

  function findOption(config, state, group, optionId) {
    return optionsFor(config, state, group).find(function (option) { return option.id === optionId; }) || null;
  }

  function isSelectable(option) {
    return Boolean(option) && option.availability === 'available';
  }

  function pairConflicts(left, right) {
    if (!left || !right || left.id === right.id) return false;
    return splitList(left.incompatibleIds).indexOf(right.id) !== -1 || splitList(right.incompatibleIds).indexOf(left.id) !== -1;
  }

  function selectedOptions(config, state) {
    return GROUP_ORDER.map(function (group) {
      return { group: group, option: findOption(config, state, group, state.selected[group]) };
    }).filter(function (entry) { return entry.option; });
  }

  function conflictsWithSelection(config, state, candidate, candidateGroup) {
    return selectedOptions(config, state).find(function (entry) {
      return entry.group !== candidateGroup && pairConflicts(candidate, entry.option);
    }) || null;
  }

  function firstSelectableOption(config, state, group) {
    var options = optionsFor(config, state, group);
    return options.find(function (option) {
      return option.isDefault && isSelectable(option) && !conflictsWithSelection(config, state, option, group);
    }) || options.find(function (option) {
      return isSelectable(option) && !conflictsWithSelection(config, state, option, group);
    }) || null;
  }

  function resetGroupSelection(config, state, group) {
    var option = firstSelectableOption(config, state, group);
    state.selected[group] = option ? option.id : null;
    return state;
  }

  function toggleSelection(config, state, group, optionId) {
    if (state.selected[group] === optionId) return resetGroupSelection(config, state, group);
    state.selected[group] = optionId;
    return state;
  }

  function isImplicitFishskinDefault(option) {
    return Boolean(option && option.group === 'fishskin' && option.isDefault);
  }

  function displayOptionName(option) {
    if (!option) return '';
    return option.name + (option.isDefault && !isImplicitFishskinDefault(option) ? COPY.baseSuffix : '');
  }

  function fishskinStyleNote(option) {
    var key = String(option && option.styleId || '') + ' ' + String(option && option.styleName || '');
    if (/ordinary|regular|普通鱼皮/i.test(key)) {
      var locale = String(
        (typeof document !== 'undefined' && document.documentElement && document.documentElement.lang) ||
        (runtime.Shopify && runtime.Shopify.locale) ||
        ''
      ).toLowerCase();
      if (locale === 'en' || locale.indexOf('en-') === 0) {
        return 'Natural surface grain with a fine, understated overall texture.';
      }
      if (
        locale === 'zh-tw' ||
        locale === 'zh-hk' ||
        locale === 'zh-mo' ||
        locale === 'zh-hant' ||
        locale.indexOf('zh-hant-') === 0
      ) {
        return '表面顆粒自然，整體質感細膩含蓄。';
      }
      return '表面颗粒自然，整体质感细腻含蓄。';
    }
    return option && option.note ? option.note : '选择后查看可用颜色';
  }

  function resetSelections(config, state) {
    state.selected = {};
    GROUP_ORDER.forEach(function (group) {
      var option = firstSelectableOption(config, state, group);
      state.selected[group] = option ? option.id : null;
    });
    return state;
  }

  function resetCurrentProductState(config, state) {
    return resetSelections(config, {
      productId: state.productId,
      activeGroup: 'fittings',
      selected: {}
    });
  }

  function buildInquiryMessage(config, state, requestNote) {
    var product = config.products.find(function (item) { return item.id === state.productId; }) || {};
    var productName = product.name || COPY.currentProduct;
    var lines = [fillCopyTemplate(COPY.inquiryIntro, { '{product}': productName })];
    GROUP_ORDER.forEach(function (group) {
      var option = findOption(config, state, group, state.selected[group]);
      var value = option ? displayOptionName(option) : COPY.unselected;
      if (group === 'fishskin' && (!option || isImplicitFishskinDefault(option))) value = COPY.unselectedKeepWood;
      lines.push(GROUPS[group].short + '：' + value);
    });
    var note = String(requestNote || '').trim();
    if (note) lines.push(COPY.otherRequirementsPrefix + note);
    return lines.join('\n');
  }

  function createInitialState(config) {
    var product = config.products.find(function (item) { return item.isDefault; }) || config.products[0] || {};
    return resetSelections(config, { productId: product.id || '', activeGroup: 'fittings', selected: {} });
  }

  function imageList(images, image) {
    var values = Array.isArray(images) ? images : [];
    return values.concat(image ? [image] : []).filter(function (value, index, all) {
      return Boolean(value) && all.indexOf(value) === index;
    });
  }

  function selectedLayers(config, state) {
    var layers = [];
    var fishskin = findOption(config, state, 'fishskin', state.selected.fishskin);
    var hasFishskinCover = Boolean(
      fishskin &&
      !isImplicitFishskinDefault(fishskin) &&
      imageList(fishskin.images, fishskin.image).length
    );
    LAYER_ORDER.forEach(function (group) {
      if (group === 'wood' && hasFishskinCover) return;
      var option = findOption(config, state, group, state.selected[group]);
      if (!option) return;
      imageList(option.images, option.image).forEach(function (image, partIndex) {
        layers.push({ group: group, image: image, partIndex: partIndex });
      });
    });
    return layers;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function init(root) {
    if (!root || root.dataset.sglDiyReady === 'true') return root && root._sglDiy;
    var configNode = root.querySelector('[data-sgl-diy-config]');
    if (!configNode) return null;

    var config;
    try { config = JSON.parse(configNode.textContent); }
    catch (error) { return null; }
    config.products = Array.isArray(config.products) ? config.products : [];
    config.options = Array.isArray(config.options) ? config.options : [];

    var configuredCopy = config.copy && typeof config.copy === 'object' ? config.copy : {};
    COPY = Object.assign({}, COPY, configuredCopy);
    var configuredGroups = configuredCopy.groups && typeof configuredCopy.groups === 'object' ? configuredCopy.groups : {};
    GROUP_ORDER.forEach(function (group) {
      GROUPS[group] = Object.assign({}, GROUPS[group], configuredGroups[group] || {});
    });

    var state = createInitialState(config);
    var controller = new AbortController();
    var signal = controller.signal;
    var toastTimer;
    var nodes = {
      productSelect: root.querySelector('[data-product-select]'),
      productNote: root.querySelector('[data-product-note]'),
      tabs: Array.from(root.querySelectorAll('[data-material-tab]')),
      progress: Array.from(root.querySelectorAll('[data-progress-step]')),
      baseImage: root.querySelector('[data-base-render]'),
      layerStack: root.querySelector('[data-layer-stack]'),
      fixedStack: root.querySelector('[data-fixed-stack]'),
      fallback: root.querySelector('[data-render-fallback]'),
      selection: root.querySelector('[data-selection-copy]'),
      stepNumber: root.querySelector('[data-step-number]'),
      stepKicker: root.querySelector('[data-step-kicker]'),
      stepTitle: root.querySelector('[data-step-title]'),
      stepHelp: root.querySelector('[data-step-help]'),
      detailNumber: root.querySelector('[data-detail-number]'),
      detailLabel: root.querySelector('[data-detail-label]'),
      detailTitle: root.querySelector('[data-detail-title]'),
      detailSummary: root.querySelector('[data-detail-summary]'),
      options: root.querySelector('[data-options]'),
      summary: root.querySelector('[data-config-summary]'),
      summaryPanel: root.querySelector('[data-summary-panel]'),
      requestNote: root.querySelector('[data-request-note]'),
      consultationPanel: root.querySelector('[data-consultation-panel]'),
      inquiryMessage: root.querySelector('[data-inquiry-message]'),
      consultationStatus: root.querySelector('[data-consultation-status]'),
      consultationChannels: Array.from(root.querySelectorAll('[data-consult-channel]')),
      copyInquiry: root.querySelector('[data-copy-inquiry]'),
      next: root.querySelector('[data-next-step]'),
      nextLabel: root.querySelector('[data-next-label]'),
      reset: root.querySelector('[data-reset]'),
      toast: root.querySelector('[data-toast]')
    };

    function prefersReducedMotion() {
      return runtime.matchMedia && runtime.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function showToast(message) {
      if (!nodes.toast) return;
      clearTimeout(toastTimer);
      nodes.toast.textContent = message;
      nodes.toast.classList.add('is-visible');
      toastTimer = setTimeout(function () { nodes.toast.classList.remove('is-visible'); }, 2400);
    }

    function hideConsultation() {
      if (nodes.consultationPanel) nodes.consultationPanel.hidden = true;
    }

    function copyInquiryMessage() {
      if (!nodes.inquiryMessage) return Promise.resolve(false);
      var message = nodes.inquiryMessage.value;
      if (runtime.navigator && runtime.navigator.clipboard && runtime.navigator.clipboard.writeText) {
        return runtime.navigator.clipboard.writeText(message).then(function () { return true; }).catch(function () { return false; });
      }
      nodes.inquiryMessage.focus();
      nodes.inquiryMessage.select();
      try { return Promise.resolve(Boolean(document.execCommand && document.execCommand('copy'))); }
      catch (error) { return Promise.resolve(false); }
    }

    function contactChannel(name) {
      return nodes.consultationChannels.find(function (link) { return link.dataset.consultChannel === name; }) || null;
    }

    function revealChannel(name, href, message) {
      var link = contactChannel(name);
      if (!link || !href) return;
      var target = href;
      if (name === 'whatsapp') {
        var whatsappUrl = /^https?:\/\//i.test(href) ? new URL(href) : new URL(href, runtime.location.origin);
        whatsappUrl.searchParams.set('text', message);
        target = whatsappUrl.toString();
      } else if (name === 'email') {
        var parts = href.split('?');
        var params = new URLSearchParams(parts[1] || '');
        params.set('subject', fillCopyTemplate(COPY.inquirySubject, { '{product}': currentProduct().name || COPY.currentProduct }));
        params.set('body', message);
        target = parts[0] + '?' + params.toString();
      }
      link.href = target;
      link.hidden = false;
    }

    function loadContactChannels(message) {
      if (!nodes.consultationPanel) return;
      var source = nodes.consultationPanel.dataset.contactSource || '/pages/contact';
      nodes.consultationChannels.forEach(function (link) {
        if (link.dataset.consultChannel !== 'contact') link.hidden = true;
      });
      if (nodes.consultationStatus) nodes.consultationStatus.textContent = COPY.consultationLoading;
      runtime.fetch(source, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('contact page unavailable');
        return response.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var whatsapp = doc.querySelector('.contact-private__channel[href*="wa.me"]');
        var email = doc.querySelector('.contact-private__channel[href^="mailto:"]');
        var line = Array.from(doc.querySelectorAll('.contact-private__channel[href]')).find(function (link) {
          var label = link.querySelector('span');
          return label && label.textContent.trim().toUpperCase() === 'LINE';
        });
        var wechat = doc.querySelector('.contact-private__wechat-image-link[href]');
        revealChannel('whatsapp', whatsapp && whatsapp.getAttribute('href'), message);
        revealChannel('email', email && email.getAttribute('href'), message);
        revealChannel('line', line && line.getAttribute('href'), message);
        revealChannel('wechat', wechat && wechat.getAttribute('href'), message);
        if (nodes.consultationStatus) nodes.consultationStatus.textContent = COPY.consultationReady;
      }).catch(function () {
        if (nodes.consultationStatus) nodes.consultationStatus.textContent = COPY.consultationUnavailable;
      });
    }

    function currentProduct() {
      return config.products.find(function (product) { return product.id === state.productId; }) || config.products[0] || {};
    }

    function formatProductNote(product) {
      var template = String(COPY.productNoteTemplate || '{summary}');
      var alternateCount = function (group) {
        return optionsFor(config, state, group).filter(function (option) { return !option.isDefault; }).length;
      };
      var fishskinTypes = [];
      optionsFor(config, state, 'fishskin').forEach(function (option) {
        if (isImplicitFishskinDefault(option)) return;
        var name = String(option.styleName || option.name || '').trim();
        if (name && fishskinTypes.indexOf(name) === -1) fishskinTypes.push(name);
      });
      var values = {
        '{product}': product.name || '',
        '{summary}': product.note || '',
        '{wood_count}': String(alternateCount('wood')),
        '{fittings_count}': String(alternateCount('fittings')),
        '{fishskin_types}': fishskinTypes.join('、')
      };
      Object.keys(values).forEach(function (token) { template = template.split(token).join(values[token]); });
      return template.trim() || product.note || COPY.productNoteFallback;
    }

    function renderProducts() {
      if (!nodes.productSelect) return;
      nodes.productSelect.innerHTML = '';
      config.products.forEach(function (product) {
        var option = document.createElement('option');
        option.value = product.id;
        option.textContent = product.name;
        option.selected = product.id === state.productId;
        nodes.productSelect.appendChild(option);
      });
      var product = currentProduct();
      nodes.productNote.textContent = formatProductNote(product);
      nodes.productSelect.closest('.sgl-diy__product').classList.toggle('is-single', config.products.length < 2);
    }

    function appendOptionButton(option, group) {
      var availabilityBlocked = option.availability !== 'available';
      var conflict = conflictsWithSelection(config, state, option, group);
      var blocked = availabilityBlocked || Boolean(conflict);
      var selected = state.selected[group] === option.id;
      var button = document.createElement('button');
      var status = availabilityBlocked ? COPY.unavailable : conflict ? COPY.conflictPrefix + GROUPS[conflict.group].short + COPY.conflictSuffix : option.note;
      button.type = 'button';
      button.dataset.optionId = option.id;
      button.className = 'sgl-diy__option' + (selected ? ' is-selected' : '') + (availabilityBlocked ? ' is-coming' : '');
      button.disabled = blocked;
      button.setAttribute('aria-pressed', String(selected));
      button.innerHTML = '<span class="sgl-diy__option-copy"><strong>' + escapeHtml(displayOptionName(option)) + '</strong><small>' + escapeHtml(status || '') + '</small></span><b aria-hidden="true">' + (selected ? '✓' : blocked ? '—' : '○') + '</b>';
      button.addEventListener('click', function () {
        toggleSelection(config, state, group, option.id);
        renderAll();
      }, { signal: signal });
      nodes.options.appendChild(button);
    }

    function renderFishskinOptions(options) {
      var current = findOption(config, state, 'fishskin', state.selected.fishskin);
      var visibleOptions = options.filter(function (option) { return !isImplicitFishskinDefault(option); });
      var styleIds = [];
      visibleOptions.forEach(function (option) {
        var styleId = option.styleId || 'none';
        if (styleIds.indexOf(styleId) === -1) styleIds.push(styleId);
      });
      var activeStyleId = current && !isImplicitFishskinDefault(current) ? (current.styleId || 'none') : '';
      var styleWrap = document.createElement('div');
      styleWrap.className = 'sgl-diy__fishskin-styles';
      var styleLabel = document.createElement('p');
      styleLabel.textContent = COPY.fishskinStylePrompt;
      styleWrap.appendChild(styleLabel);

      styleIds.forEach(function (styleId) {
        var styleOptions = visibleOptions.filter(function (option) { return (option.styleId || 'none') === styleId; });
        var first = styleOptions[0];
        var selectable = styleOptions.find(function (option) { return isSelectable(option) && !conflictsWithSelection(config, state, option, 'fishskin'); });
        var button = document.createElement('button');
        var active = styleId === activeStyleId;
        button.type = 'button';
        button.className = 'sgl-diy__fishskin-style' + (active ? ' is-selected' : '');
        button.disabled = !selectable;
        button.setAttribute('aria-pressed', String(active));
        button.innerHTML = '<strong>' + escapeHtml(first.styleName || first.name) + '</strong><small>' + escapeHtml(selectable ? fishskinStyleNote(first) : COPY.unavailable) + '</small>';
        button.addEventListener('click', function () {
          if (!selectable) return;
          if (active) resetGroupSelection(config, state, 'fishskin');
          else state.selected.fishskin = selectable.id;
          renderAll();
        }, { signal: signal });
        styleWrap.appendChild(button);
      });
      nodes.options.appendChild(styleWrap);

      var colorOptions = options.filter(function (option) { return (option.styleId || 'none') === activeStyleId && option.colorName; });
      if (!colorOptions.length) return;
      var colorWrap = document.createElement('div');
      colorWrap.className = 'sgl-diy__fishskin-colors';
      colorWrap.innerHTML = '<p>' + escapeHtml(COPY.fishskinColorPrompt) + '</p>';
      colorOptions.forEach(function (option) {
        var conflict = conflictsWithSelection(config, state, option, 'fishskin');
        var blocked = option.availability !== 'available' || Boolean(conflict);
        var selected = state.selected.fishskin === option.id;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sgl-diy__fishskin-color' + (selected ? ' is-selected' : '');
        button.disabled = blocked;
        button.setAttribute('aria-pressed', String(selected));
        button.innerHTML = '<i style="--sgl-diy-swatch:' + escapeHtml(option.swatch || '#8b7b68') + '" aria-hidden="true"></i><span>' + escapeHtml(option.colorName) + '</span>';
        button.addEventListener('click', function () {
          toggleSelection(config, state, 'fishskin', option.id);
          renderAll();
        }, { signal: signal });
        colorWrap.appendChild(button);
      });
      nodes.options.appendChild(colorWrap);
    }

    function renderNavigation() {
      var group = GROUPS[state.activeGroup];
      var index = GROUP_ORDER.indexOf(state.activeGroup);
      nodes.stepNumber.textContent = group.number;
      nodes.stepKicker.textContent = group.short;
      nodes.stepTitle.textContent = group.title;
      nodes.stepHelp.textContent = group.help;
      nodes.detailNumber.textContent = group.number;
      nodes.detailLabel.textContent = group.label;
      nodes.detailTitle.textContent = group.short;
      nodes.detailSummary.textContent = group.summary;

      nodes.tabs.forEach(function (tab, tabIndex) {
        var selected = tab.dataset.materialTab === state.activeGroup;
        tab.classList.toggle('is-selected', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        nodes.progress[tabIndex].classList.toggle('is-current', tabIndex === index);
        nodes.progress[tabIndex].classList.toggle('is-done', tabIndex < index);
      });

      nodes.next.querySelector('span').textContent = index < GROUP_ORDER.length - 1 ? COPY.nextLabel : COPY.completeLabel;
      nodes.nextLabel.textContent = index < GROUP_ORDER.length - 1 ? GROUPS[GROUP_ORDER[index + 1]].short : COPY.enterConsultation;
    }

    function renderOptions() {
      var group = state.activeGroup;
      var options = optionsFor(config, state, group);
      nodes.options.innerHTML = '';
      nodes.options.classList.toggle('is-card-grid', group !== 'fishskin');
      if (!options.length) {
        nodes.options.innerHTML = '<p class="sgl-diy__empty">' + escapeHtml(COPY.noGroupMaterials) + '</p>';
        return;
      }
      if (group === 'fishskin') renderFishskinOptions(options);
      else options.filter(function (option) { return option.group !== 'fishskin'; }).forEach(function (option) { appendOptionButton(option, group); });
    }

    function renderStage() {
      var product = currentProduct();
      var layers = selectedLayers(config, state);
      nodes.baseImage.hidden = !product.baseImage;
      if (product.baseImage) nodes.baseImage.src = product.baseImage;
      else nodes.baseImage.removeAttribute('src');
      nodes.layerStack.innerHTML = '';
      layers.forEach(function (layer) {
        var image = document.createElement('img');
        image.src = layer.image;
        image.alt = '';
        image.dataset.layerGroup = layer.group;
        image.dataset.layerPart = String(layer.partIndex);
        image.decoding = 'async';
        nodes.layerStack.appendChild(image);
      });
      nodes.fixedStack.innerHTML = '';
      imageList(product.fixedImages, product.fixedImage).forEach(function (source, partIndex) {
        var image = document.createElement('img');
        image.src = source;
        image.alt = '';
        image.dataset.fixedPart = String(partIndex);
        image.decoding = 'async';
        nodes.fixedStack.appendChild(image);
      });
      nodes.fallback.hidden = Boolean(product.baseImage);
      var names = GROUP_ORDER.map(function (group) {
        var option = findOption(config, state, group, state.selected[group]);
        if (isImplicitFishskinDefault(option)) return '';
        return option ? displayOptionName(option) : '';
      }).filter(Boolean);
      nodes.selection.textContent = (product.name || '当前单品') + (names.length ? ' · ' + names.join(' · ') : '');
    }

    function renderSummary() {
      nodes.summary.innerHTML = '';
      GROUP_ORDER.forEach(function (group) {
        var option = findOption(config, state, group, state.selected[group]);
        if (!option || isImplicitFishskinDefault(option)) return;
        var item = document.createElement('li');
        item.innerHTML = '<span>' + escapeHtml(GROUPS[group].short) + '</span><strong>' + escapeHtml(displayOptionName(option)) + '</strong>';
        nodes.summary.appendChild(item);
      });
    }

    function renderAll() {
      hideConsultation();
      renderProducts();
      renderNavigation();
      renderOptions();
      renderStage();
      renderSummary();
    }

    function completeConfiguration() {
      if (!nodes.summaryPanel || !nodes.requestNote || !nodes.consultationPanel || !nodes.inquiryMessage) return;
      var message = buildInquiryMessage(config, state, nodes.requestNote.value);
      nodes.summaryPanel.open = true;
      nodes.inquiryMessage.value = message;
      nodes.consultationPanel.hidden = false;
      try { runtime.sessionStorage.setItem('sglDiyInquiry', message); }
      catch (error) { /* 浏览器禁用存储时不影响当前页咨询 */ }
      loadContactChannels(message);
      var revealConsultation = function () {
        nodes.consultationPanel.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      };
      if (runtime.requestAnimationFrame) runtime.requestAnimationFrame(revealConsultation);
      else revealConsultation();
      showToast(COPY.matchingRecorded);
    }

    if (nodes.productSelect) nodes.productSelect.addEventListener('change', function () {
        state.productId = nodes.productSelect.value;
        state.activeGroup = 'fittings';
        resetSelections(config, state);
        renderAll();
      }, { signal: signal });

    nodes.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        state.activeGroup = tab.dataset.materialTab;
        renderAll();
      }, { signal: signal });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var index = GROUP_ORDER.indexOf(state.activeGroup);
        state.activeGroup = GROUP_ORDER[(index + (event.key === 'ArrowRight' ? 1 : -1) + GROUP_ORDER.length) % GROUP_ORDER.length];
        renderAll();
        nodes.tabs[GROUP_ORDER.indexOf(state.activeGroup)].focus();
      }, { signal: signal });
    });

    nodes.next.addEventListener('click', function () {
      var index = GROUP_ORDER.indexOf(state.activeGroup);
      if (index < GROUP_ORDER.length - 1) {
        state.activeGroup = GROUP_ORDER[index + 1];
        renderAll();
      } else completeConfiguration();
    }, { signal: signal });

    nodes.reset.addEventListener('click', function () {
      state = resetCurrentProductState(config, state);
      renderAll();
      showToast(COPY.restoreCurrentProduct);
    }, { signal: signal });

    if (nodes.copyInquiry) nodes.copyInquiry.addEventListener('click', function () {
      copyInquiryMessage().then(function (copied) {
        showToast(copied ? COPY.inquiryCopied : COPY.inquiryCopyFailed);
      });
    }, { signal: signal });

    nodes.consultationChannels.forEach(function (link) {
      if (link.dataset.consultChannel !== 'line' && link.dataset.consultChannel !== 'wechat') return;
      link.addEventListener('click', function () { copyInquiryMessage(); }, { signal: signal });
    });

    function onBlockSelect(event) {
      var block = event.target.closest('[data-block-id]');
      if (!block || !root.contains(block)) return;
      var product = config.products.find(function (item) { return item.blockId === block.dataset.blockId; });
      var option = config.options.find(function (item) { return item.blockId === block.dataset.blockId; });
      if (product) {
        state.productId = product.id;
        state.activeGroup = 'fittings';
        resetSelections(config, state);
      }
      if (option) {
        state.productId = option.productId;
        state.activeGroup = option.group;
        resetSelections(config, state);
        if (isSelectable(option)) state.selected[option.group] = option.id;
      }
      renderAll();
    }

    document.addEventListener('shopify:block:select', onBlockSelect, { signal: signal });
    var instance = {
      state: function () { return state; },
      render: renderAll,
      destroy: function () {
        controller.abort();
        clearTimeout(toastTimer);
        root.dataset.sglDiyReady = 'false';
        delete root._sglDiy;
      }
    };
    root.dataset.sglDiyReady = 'true';
    root._sglDiy = instance;
    renderAll();
    return instance;
  }

  function initAll(scope) {
    return Array.from((scope || document).querySelectorAll('[data-sgl-diy-configurator]')).map(init).filter(Boolean);
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-sgl-diy-configurator]');
      if (root && root._sglDiy) root._sglDiy.destroy();
    });
  }

  return {
    GROUP_ORDER: GROUP_ORDER,
    LAYER_ORDER: LAYER_ORDER,
    GROUPS: GROUPS,
    splitList: splitList,
    imageList: imageList,
    optionsFor: optionsFor,
    isSelectable: isSelectable,
    pairConflicts: pairConflicts,
    selectedLayers: selectedLayers,
    toggleSelection: toggleSelection,
    isImplicitFishskinDefault: isImplicitFishskinDefault,
    displayOptionName: displayOptionName,
    resetSelections: resetSelections,
    resetCurrentProductState: resetCurrentProductState,
    buildInquiryMessage: buildInquiryMessage,
    createInitialState: createInitialState,
    init: init,
    initAll: initAll
  };
});

